<template>
  <div class="ma-4">
    <v-sheet v-show="showSkeleton" class="pa-3">
      <v-skeleton-loader class="mx-auto" type="table" />
    </v-sheet>

    <div v-show="!showSkeleton" class="text-h4 mb-2">Departamentos</div>

    <v-dialog v-model="dialog">
      <v-card>
        <v-card-text>
          <Dialog  :departamento="departamento" />
        </v-card-text> 

        <v-divider />

        <v-card-actions>
        <v-spacer />
            <v-btn color="blue darken-1" text @click="dialog = false">Sair</v-btn>
        </v-card-actions> 
      </v-card>  
    </v-dialog> 

    <v-data-iterator
      v-show="!showSkeleton"
      :no-data-text="noDataText"
      :items="dataDepartamentos"
      :items-per-page.sync="itemsPerPage"
      :page="page"
      :search="search"
      :no-results-text="noResultsText"
      hide-default-footer
    >
      <template v-slot:header>
        <v-row>
          <v-col cols="7" class="my-2">
            <v-btn
              v-if="permissaoTotal"
              dark
              color="orangePcm"
              href="/central-de-atendimento/cadastro/departamento/criar"
              target="_blank"
              @click="handleGoToNewDepartamento"
              class="mr-2"
            >
              Criar Departamento
            </v-btn>
          </v-col>
          <v-spacer />
          <v-col cols="4" class="mr-2">
            <v-text-field v-model="search" clearable hide-details prepend-inner-icon="mdi-magnify" label="Busca" />
          </v-col>
        </v-row>
      </template>

      <template v-slot:default="props">
        <v-data-table
          dense
          :headers="headers"
          :items="props.items"
          hide-default-footer
          class="elevation-1"
          disable-pagination
          @dblclick:row="atualizar"
        >
          <template v-slot:[`item.botoes`]="{ item }">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  icon
                  small
                  dark
                  color="bluePcm"
                  class="ma-2"
                  target="_blank"
                  v-bind="attrs"
                  v-on="on"
                  @click="openDialog(item)"
                >
                  <v-icon>mdi-eye</v-icon>
                </v-btn>
              </template>
              <span>Uso</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  icon
                  small
                  dark
                  color="bluePcm"
                  :href="`/central-de-atendimento/cadastro/departamento/atualizar/${item._id}`"
                  target="_blank"
                  v-bind="attrs"
                  v-on="on"
                  class="ma-2"
                  @click="atualizarButton($event, item)"
                >
                  <v-icon>mdi-pencil</v-icon>
                </v-btn>
              </template>
              <span>Editar</span>
            </v-tooltip>

            <v-tooltip bottom v-if="permissaoTotal">
              <template v-slot:activator="{ on, attrs }">
                <v-btn @click="deletar(item)" icon small dark color="darkRed" v-bind="attrs" v-on="on">
                  <v-icon>mdi-trash-can-outline</v-icon>
                </v-btn>
              </template>
              <span>Remover</span>
            </v-tooltip>
          </template>
        </v-data-table>
      </template>

      <template v-slot:footer>
        <v-row class="mt-2" align="center" justify="center">
          <div class="ml-4 mb-2 grey--text">
            <p>Departamentos: {{ qtdDepartamentos }}</p>
          </div>
          <v-spacer />
          <div class="pb-5">
            <ListPagination
              :page="page"
              :numberOfPages="numberOfPages"
              @firstPage="firstPage"
              @formerPage="formerPage"
              @nextPage="nextPage"
              @lastPage="lastPage"
            />
          </div>
        </v-row>
      </template>
    </v-data-iterator>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

import ListPagination from '@/componentes/ListPagination'
import { pagesHomeMixins } from '@/mixins/pagesHomeMixins'
import { registerVuexModule } from '@/utils/vuexUtils'
import { obtainUserPermissions } from '@/utils/obtainUserPermissions'

import departamentosStore from '../_store'
import departamentosHttpService from '../_services/departamentosHttpService'
import Dialog from '../_components/Dialog.vue'

export default {
  components: { ListPagination, Dialog },

  mixins: [pagesHomeMixins],

  data: () => ({
    dataDepartamentos: [],
    headers: [
      {
        text: 'Departamento',
        value: 'description',
        align: 'left',
      },
      {
        text: 'Código',
        value: 'codigo',
        // align: 'left',
      },
      {
        text: 'Ações',
        value: 'botoes',
        align: 'center',
        sortable: false,
      },
    ],
    permissaoTotal: false,
    arrayPermissaoTotal: [
      process.env.VUE_APP_CALLCENTER_CADASTRO_DEPARTAMENTO_TOTAL,
      process.env.VUE_APP_ADMINISTRADOR,
    ],
    dialog: false,
    departamento: {},
  }),

  computed: {
    ...mapGetters('departamentosHomeModuleCallCenterStore', ['getDepartamentos']),

    numberOfPages() {
      return Math.ceil(this.dataDepartamentos.length / this.itemsPerPage)
    },

    qtdDepartamentos() {
      return this.dataDepartamentos.length
    },
  },

  async created() {
    registerVuexModule(this.$store, 'departamentosHomeModuleCallCenterStore', departamentosStore)

    await this.listarTodosDepartamentos()
    this.dataDepartamentos = [...this.getDepartamentos]
    this.dataDepartamentos.sort((a,b) => a.codigo - b.codigo);


    const arrayPermissions = this.arrayPermissionsFromLocalStorage()

    arrayPermissions.forEach(permissaoLocalStorage => {
      if (this.arrayPermissaoTotal.includes(permissaoLocalStorage)) {
        this.permissaoTotal = true
      }
    })

    this.showSkeleton = false
  },

  methods: {
    ...mapActions('departamentosHomeModuleCallCenterStore', ['listarTodosDepartamentos', 'listarDepartamentoUse']),
    ...obtainUserPermissions,

    handleGoToNewDepartamento(event) {
      event.preventDefault()
      if (event.metaKey || event.ctrlKey) {
        const goToNewDepartamento = this.$router.resolve({ name: 'Departamento/criar' })
        window.open(goToNewDepartamento.href, '_blank')
      } else {
        this.$router.push({ name: 'Departamento/criar' })
      }
    },

    atualizar(event, item) {
      if (event.metaKey || event.ctrlKey) {
        const updatePath = this.$router.resolve(`departamento/atualizar/${item.item._id}`)
        window.open(updatePath.href, '_blank')
      } else {
        this.$router.push(`departamento/atualizar/${item.item._id}`)
      }
    },

    atualizarButton(event, item) {
      event.preventDefault()
      if (event.metaKey || event.ctrlKey) {
        const updatePath = this.$router.resolve(`departamento/atualizar/${item._id}`)
        window.open(updatePath.href, '_blank')
      } else {
        this.$router.push(`departamento/atualizar/${item._id}`)
      }
    },

    async deletar(item) {
      let resultado = window.confirm(`Deseja remover o departamento "${item.description}"?`)
      if (resultado) {
        try {
          await departamentosHttpService.deleteDepartamento(item._id)
          this.dataDepartamentos = this.dataDepartamentos.filter(indexDepartamento => indexDepartamento._id !== item._id)
        } catch (error) {
          alert(error.response.data)
        }
      }
    },
    async openDialog(departamento) {
      await this.listarDepartamentoUse(departamento._id)
      this.departamento = departamento
      this.dialog = true
    }
  },
}
</script>
